/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  const Sage = {
    // All pages
    common: {
      init() {},
      finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $('.signup-form').submit(function (e) {
          e.preventDefault();

          const $form = $(this);
          const url = $form.attr('action');
          const list = $form.find('input[name="list"]').val();
          let redirect = '';

          switch (list) {
            case 'NzoALo5AUU8a7QTyKKFWSg':
              redirect = '/telechargement-du-plan-de-strategie-digitale/';
              break;
            case 'PU8UM45XaJgdfbW6WMteEg':
              redirect =
                '/telechargement-de-la-feuille-de-calcul-estimation-de-budget-de-creation-de-site-internet/';
              break;
            case 'Wr0iuo892Caw0iDtTMnhkL2w':
              redirect = '/validation';
              break;
            default:
              redirect = '/';
          }

          $.post(url, $form.serialize(), (data) => {
            if (data) {
              if (data == 'Some fields are missing.') {
                $('#status').text('Merci de remplir tous les champs requis.');
                $('#status').css('color', 'red').show();
              } else if (data == 'Invalid email address.') {
                $('#status').text('Adresse e-mail invalide.');
                $('#status').css('color', 'red').show();
              } else if (data == 'Invalid list ID.') {
                $('#status').text(
                  "Erreur de paramétrage. ID de liste non configuré. Merci de contacter l'administrateur."
                );
                $('#status').css('color', 'red').show();
              } else if (data == 'Already subscribed.') {
                $('#status').text('Merci. Vous allez être redirigé...');
                $('#status').css('color', 'green').show();
                window.location.replace(redirect);
              } else {
                $('#status').text('Merci. Vous allez être redirigé...');
                $('#status').css('color', 'green').show();
                window.location.replace(redirect);
              }
            } else {
              $('#status').text(
                "Oups, quelque chose s'est mal déroulé. Merci de rééssayer plus tard ou de contacter un administrateur."
              );
              $('#status').css('color', 'red').show();
            }
          });
        });
        $('.signup-form').keypress(function (e) {
          if (e.keyCode == 13) {
            e.preventDefault();
            $(this).submit();
          }
        });
        $('.submit-btn').click(function (e) {
          e.preventDefault();
          $(this).closest('.signup-form').submit();
        });
      },
    },
    // Home page
    home: {
      init() {
        // JavaScript to be fired on the home page
        // $('.header-accueil').vide({
        //     webm: '/wp-content/themes/bridge-child/dist/images/creation-site-internet-nice.webm',
        //     mp4: '/wp-content/themes/bridge-child/dist/images/creation-site-internet-nice.mp4',
        //     ogv: '/wp-content/themes/bridge-child/dist/images/creation-site-internet-nice.ogv',
        //     poster: '/wp-content/themes/bridge-child/dist/images/image_mockupgratuit.jpg'
        // }, {
        //     loop: true,
        //     autoplay: true,
        //     position: '50% 50%', // Similar to the CSS `background-position` property.
        //     posterType: 'jpg', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
        //     resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
        //     bgColor: 'transparent', // Allow custom background-color for Vide div,
        //     className: 'videoaccueil' // Add custom CSS class to Vide div
        // });
        // $("#bgndVideo").mb_YTPlayer();
      },
      finalize() {
        // JavaScript to be fired on the home page, after the init JS
        $('.header-accueil > div:last-child').fadeIn();
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init() {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire(func, funcname, args) {
      let fire;
      const namespace = Sage;
      // eslint-disable-next-line no-param-reassign
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, '_').split(/\s+/),
        (i, classnm) => {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        }
      );

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
